<div class="modern-admin-page">
  <!-- Page Header -->
  <div class="page-header-card">
    <div class="header-content">
      <div class="page-title-section">
        <h1 class="page-title bangla-heading">প্রোফাইল সেটিংস</h1>
        <p class="page-subtitle bangla-text">আপনার একাউন্টের তথ্য পরিবর্তন করুন</p>
      </div>
      <div class="page-actions">
        <button type="button" class="btn-secondary-modern" (click)="goBack()">
          <i class="fas fa-arrow-left"></i>
          ড্যাশবোর্ডে ফিরুন
        </button>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="content-card">
    <div class="loading-state">
      <div class="loading-spinner">
        <i class="fas fa-spinner fa-spin"></i>
        <p class="bangla-text">ডেটা লোড হচ্ছে...</p>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div *ngIf="!isLoading" class="content-grid">
    <form (ngSubmit)="onSubmit()" class="modern-form">
      
      <!-- User Profile Display Section -->
      <div class="content-card slide-up">
        <div class="card-header">
          <h3 class="card-title bangla-title">
            <i class="fas fa-user-circle"></i>
            বর্তমান প্রোফাইল
          </h3>
        </div>
        
        <div class="card-body">
          <div class="user-info-section">
            <div class="user-avatar">
              <i class="fas fa-user"></i>
            </div>
            <div class="user-details">
              <h4 class="user-name bangla-text">{{ currentUser?.username || 'Unknown User' }}</h4>
              <span class="user-role-badge">{{ getUserRole() }}</span>
              <p class="user-email">{{ currentUser?.email || 'No email provided' }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Basic Information Section -->
      <div class="content-card slide-up">
        <div class="card-header">
          <h3 class="card-title bangla-title">
            <i class="fas fa-edit"></i>
            ব্যক্তিগত তথ্য
          </h3>
        </div>
        
        <div class="card-body">
          <div class="form-row">
            <div class="form-group">
              <label class="form-label bangla-label required">ব্যবহারকারীর নাম *</label>
              <input 
                [(ngModel)]="profileForm.username" 
                name="username" 
                type="text" 
                class="form-control" 
                placeholder="আপনার ব্যবহারকারীর নাম"
                required>
            </div>
            
            <div class="form-group">
              <label class="form-label bangla-label required">ইমেইল ঠিকানা *</label>
              <input 
                [(ngModel)]="profileForm.email" 
                name="email" 
                type="email" 
                class="form-control" 
                placeholder="example@domain.com"
                required>
            </div>
          </div>
          
          <div class="form-row">
            <div class="form-group">
              <label class="form-label bangla-label">ব্যবহারকারীর ভূমিকা</label>
              <div class="role-display">
                <span class="current-role-badge">{{ getUserRole() }}</span>
                <small class="role-note bangla-text">ভূমিকা পরিবর্তন করতে অ্যাডমিনের সাথে যোগাযোগ করুন</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Password Section -->
      <div class="content-card slide-up">
        <div class="card-header">
          <h3 class="card-title bangla-title">
            <i class="fas fa-lock"></i>
            পাসওয়ার্ড পরিবর্তন
          </h3>
        </div>
        
        <div class="card-body">
          <div class="form-row">
            <div class="form-group">
              <label class="form-label bangla-label">বর্তমান পাসওয়ার্ড</label>
              <input 
                [(ngModel)]="profileForm.currentPassword" 
                name="currentPassword" 
                type="password" 
                class="form-control" 
                placeholder="আপনার বর্তমান পাসওয়ার্ড">
              <small class="form-hint bangla-text">পাসওয়ার্ড পরিবর্তনের জন্য বর্তমান পাসওয়ার্ড প্রয়োজন</small>
            </div>
          </div>
          
          <div class="form-row">
            <div class="form-group">
              <label class="form-label bangla-label">নতুন পাসওয়ার্ড</label>
              <input 
                [(ngModel)]="profileForm.newPassword" 
                name="newPassword" 
                type="password" 
                class="form-control" 
                placeholder="নতুন পাসওয়ার্ড (ঐচ্ছিক)">
              <small class="form-hint bangla-text">খালি রাখলে পাসওয়ার্ড পরিবর্তন হবে না</small>
            </div>
            
            <div class="form-group">
              <label class="form-label bangla-label">পাসওয়ার্ড নিশ্চিত করুন</label>
              <input 
                [(ngModel)]="profileForm.confirmPassword" 
                name="confirmPassword" 
                type="password" 
                class="form-control" 
                placeholder="পাসওয়ার্ড পুনরায় লিখুন">
            </div>
          </div>
          
          <div class="password-requirements">
            <h6 class="requirements-title bangla-text">পাসওয়ার্ডের শর্তাবলী:</h6>
            <ul class="requirements-list bangla-text">
              <li>বর্তমান পাসওয়ার্ড সঠিকভাবে দিতে হবে</li>
              <li>নতুন পাসওয়ার্ড কমপক্ষে ৬ অক্ষর হতে হবে</li>
              <li>নতুন পাসওয়ার্ড বর্তমান পাসওয়ার্ড থেকে আলাদা হতে হবে</li>
              <li>নিরাপত্তার জন্য শক্তিশালী পাসওয়ার্ড ব্যবহার করুন</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Form Actions -->
      <div class="content-card">
        <div class="card-body">
          <div class="form-actions">
            <button type="button" class="btn-secondary-modern bangla-text" (click)="goBack()">
              <i class="fas fa-times"></i>
              বাতিল
            </button>
            <button type="submit" class="btn-primary-modern bangla-text" [disabled]="isSaving">
              <i class="fas fa-save" *ngIf="!isSaving"></i>
              <i class="fas fa-spinner fa-spin" *ngIf="isSaving"></i>
              {{ isSaving ? 'সংরক্ষণ হচ্ছে...' : 'পরিবর্তন সংরক্ষণ করুন' }}
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div> 